import { Heading } from "@/components/ui/heading";
import { RegularPageLayout } from "@/components/layout/PageLayouts";
export default function ContactPage() {
	const contactEmail = import.meta.env.VITE_CONTACT_EMAIL || "info@textformatter.pro";

	return (
		<RegularPageLayout width="6xl" paddingY="8">
			<section className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
				<Heading>Contact</Heading>
				<div className="mt-6 space-y-4 text-sm leading-7 text-slate-700 sm:text-base">
					<p>For product questions, support, or business inquiries, contact us by email.</p>
					<p>
						Email:{" "}
						<a
							className="font-medium text-ink underline underline-offset-2"
							href={`mailto:${contactEmail}`}
						>
							{contactEmail}
						</a>
					</p>
				</div>
			</section>
		</RegularPageLayout>
	);
}
